<template>
  <li :class="'nav-item'+isActive(pageid)">
    <a class="nav-link" @click="$router.push({name: pageid})">
      <span class="nav-icon">
        <font-awesome-icon :icon="$t(`PAGES.${pageid}.icon`)" fixed-width />
      </span>
      <span class="nav-text"> {{ $t(`PAGES.${pageid}.title`) }}</span>
    </a>
  </li>
</template>

<script>
export default {
  props: ['pageid'],
  methods: {
    isActive (name) {
      return this.$store.state.activeItem === name ? ' active' : ''
    }
  }
}
</script>

<style scoped>
a {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/adminparts/SideItem.vue